// Configuration for FlashSync UI
const fallbackServerUrl = (() => {
  if (process.env.REACT_APP_DEFAULT_SERVER_URL) {
    return process.env.REACT_APP_DEFAULT_SERVER_URL;
  }

  if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
    return window.location.origin;
  }

  return 'http://localhost:8080';
})();

const config = {
  // Default server URL - can be overridden by environment variables
  defaultServerUrl: fallbackServerUrl,
  
  // App name
  appName: 'FlashSync',
  
  // Other configuration options
  features: {
    collapsibleServerUrl: true, // Whether to make server URL input collapsible
  }
};

export default config;
